/**
 * "N concepts" / "N of M concepts" in the Knowledge Archive header —
 * ROUTE_INVENTORY §2.10 #8.
 *
 * Three states, and the first one is the reason this is a component rather
 * than an inline ternary:
 *
 * - **Counts not in yet** → a transparent `-`. Not `null`, not a spinner. The
 *   badge sits in a fixed-width slot to the left of the search input, and
 *   rendering nothing would collapse the slot and jog the search bar sideways
 *   the moment the fetch lands. A spinner would be worse: the page already has
 *   a body-level loading state, and two spinners for one fetch reads as two
 *   fetches.
 * - **Capped** (`total` differs from `visible`) → "300 of 1,247 concepts", so
 *   the number on screen is never mistaken for the whole mindspace.
 * - **Complete** → "N concept(s)", singular-aware.
 */

interface NodeCountBadgeProps {
  /** Nodes currently rendered. */
  visible: number;
  /** Total the server says exist, or `null` before the response lands. */
  total: number | null;
}

export function NodeCountBadge({ visible, total }: NodeCountBadgeProps) {
  if (visible === 0 && total == null) {
    return <span className='text-xs text-transparent'>-</span>;
  }
  if (total != null && total !== visible) {
    return (
      <span className='text-xs tabular-nums text-muted-foreground'>
        {visible} of {total.toLocaleString()} concepts
      </span>
    );
  }
  return (
    <span className='text-xs tabular-nums text-muted-foreground'>
      {visible} concept{visible === 1 ? '' : 's'}
    </span>
  );
}
